import _ from 'lodash';
import React, { useContext } from 'react';
import { LayoutContext } from 'contexts/LayoutContext';
import { AccountsTransfersStackRoutes, AccountsTransfersStackScreenProps } from './type';

import { AccountSelectWebScreen } from './AccountSelectWeb.screen';
import { AccountSelectNativeScreen } from './AccountSelectNative.screen';

export interface AccountSelectScreenProps {}

export const AccountSelectScreen: React.FC<AccountsTransfersStackScreenProps<AccountsTransfersStackRoutes.AccountSelect>> = ({
  navigation,
  route
}) => {
  const layout = useContext(LayoutContext);
  const { onLayout, onSelect, asset, otherSelectedId, onChangeView, subaccountFlag, balanceAllFlag } = route.params;

  if (layout.isMobile) {
    return (
      <AccountSelectNativeScreen
        onSelect={onSelect}
        asset={asset}
        otherSelectedId={otherSelectedId}
        subaccountFlag={subaccountFlag}
        balanceAllFlag={balanceAllFlag}
      />
    );
  }
  return (
    <AccountSelectWebScreen
      onLayout={onLayout}
      onSelect={onSelect}
      asset={asset}
      otherSelectedId={otherSelectedId}
      onChangeView={onChangeView}
      subaccountFlag={subaccountFlag}
      balanceAllFlag={balanceAllFlag}
    />
  );
};
